import axios from '@/services/axiosConfig'

const endPoint = {
	createInstitute: () => '/institute/simple',
}

const instituteCreateAPI = {
	createInstitute: params => axios.post(endPoint.createInstitute(), params),
}

export default instituteCreateAPI
